import request from "../utils/request";
import requestGaoding from "../utils/requestGaoding";

// https://yapi.gaoding.com/project/1717/interface/api/163868
/**
 * 获取领券详情
 * @returns
 */
export async function getActivity({ activity_code }) {
  return request({
    url: `/biz/activity-info/${activity_code}`,
  });
}

// https://yapi.gaoding.com/project/1717/interface/api/146354
/**
 * 获取领券详情
 * @returns
 */
export async function pickCoupons({ activity_code, coupon_ids }) {
  return request({
    url: "/biz/users/coupons",
    method: "post",
    data: {
      activity_code,
      coupon_ids,
    },
  });
}

/**
 * 检查活动是否可以参与
 * @param {{
 *  currentOrgId: string;
 *  activity_code: string;
 *  batch_check_org_info: {org_id: string}[]
 * }} data
 * @returns {Promise<{canJoin: boolean;
 *  canJoinOrg: {org_id: string};}>}
 */
export async function checkCouponActivity({
  currentOrgId,
  activity_code,
  batch_check_org_info,
}) {
  return requestGaoding({
    url: "/trade/coupon-activities/check",
    method: "post",
    data: {
      activity_code,
      batch_check_org_info,
    },
  }).then((res) => {
    if (res.err) {
      // 错误场景返回空对象
      return {};
    }

    const orgsMap = batch_check_org_info.reduce((prev, curr) => {
      return {
        ...prev,
        [curr.org_id]: curr,
      };
    }, {});
    const batches = res?.batch_result || [];
    const canJoinOrg = orgsMap[batches.find((item) => item.can_join)?.org_id];
    const currentOrg = batches.find((item) => item.org_id === currentOrgId);

    return {
      // 当前租户信息
      currentOrg,
      // 当前租户是否可以参加活动
      canJoin: currentOrg?.can_join,
      // 当前可以参加的租户信息
      canJoinOrg,
    };
  });
}
